import { useState } from 'react';
import { Newspaper, Play, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { mastraClient } from '@/lib/mastra-client';

export function NewsHunterPage() {
  const [running, setRunning] = useState(false);

  const handleRun = async () => {
    setRunning(true);
    try {
      const run = await mastraClient.getWorkflow('news-hunter').createRun();
      await run.start({
        inputData: {
          triggeredAt: new Date().toISOString(),
          keywords: ['monitoring', 'calibration', 'datalogger', 'sensor'],
        },
      });
      toast.success('News Hunter started', { description: `Run ID: ${run.runId}` });
    } catch (err) {
      toast.error('Failed to start News Hunter', { description: err instanceof Error ? err.message : 'Unknown error' });
    } finally {
      setRunning(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Newspaper className="h-5 w-5" />
          <h1 className="text-xl font-semibold">News</h1>
        </div>
        <Button size="sm" onClick={handleRun} disabled={running}>
          {running ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <Play className="h-4 w-4 mr-1" />}
          {running ? 'Running…' : 'Run'}
        </Button>
      </div>

      <div className="flex items-center justify-center h-[40vh] text-muted-foreground">
        <div className="text-center space-y-2">
          <Newspaper className="h-8 w-8 mx-auto opacity-40" />
          <p>News Hunter — coming soon</p>
        </div>
      </div>
    </div>
  );
}
